import React, { useMemo, useState } from 'react'
import { useParams } from 'react-router-dom'
import useQueryString from '../../../../hooks/use-query-string'
import useBackgroundsFromPackage from '../../package-builder/use-backgrounds-from-package'
import styles from './BackgroundSelection.module.scss'
import useOrder from './useOrder'
import Item from './Item'
import Button from '../../../Button';
import orderPackage from '../../../../models/OrderPackage';
import { toast, ToastContainer } from 'react-toastify';
import Spinner from '../../../Spinner';

export default function BackgroundSelection() {
  const { orderId } = useParams()
  const { email } = useQueryString()
  const { isLoading, data: order } = useOrder({ email, orderId })
  const [isSubmitting, setIsSubmitting] = useState(false)

  const packageId = useMemo(() => {
    if (!order) return null

    return order.cart.orderPackages[0].packageId
  }, [order && order.id])

  const backgrounds = useBackgroundsFromPackage(packageId)

  const handleSubmit = () => {
    setIsSubmitting(true)

    order
      .save({ with: { cart: { orderPackages: { sheets: ['imageType', 'pose', 'background'] } } } })
      .then((res) => {
        if (res) {
          toast('Your order has been updated.', { type: 'success' })
        } else {
          toast('There was a problem updating your order.', { type: 'error' })
        }
      })
      .finally(() => setIsSubmitting(false))
  }

  if (isLoading || !backgrounds) return <div className={styles.container} style={{ display: 'flex', justifyContent: 'center' }}><Spinner color="blue" /></div>

  return (
    <div className={styles.container}>
      <ToastContainer />
      <div style={{ textAlign: 'center', marginBottom: '2em', lineHeight: '1.5rem' }}>
        Please select which backgrounds you would like for each sheet.
        <br />
        Once you are finished, please submit your choices.
      </div>
      <div className={styles.grid}>
        {order
          .cart
          .orderPackages
          // .filter((orderPackage) => orderPackage.sheets.some((sheet) => !sheet.backgroundId))
          .map((orderPackage) => (
            orderPackage
              .sheets
              .filter((sheet) => !sheet.imageType.name.toLowerCase().includes('class'))
              .map((sheet) => (
                <Item sheet={sheet} backgrounds={backgrounds} orderPackage={orderPackage} />
              ))))}
      </div>
      <div style={{ marginTop: '2em', textAlign: 'center' }}>
        <Button variant="primary" onClick={handleSubmit} disabled={isSubmitting}>Submit</Button>
      </div>
    </div>
  )
}
